<template>
	<div>
		<buttonlist @help="help" @opentable="opentable" @search="search" @reflash="reflash" @imp="imp" @exps="exps" ref="SetBtn"></buttonlist>
		<div>
			<wTable
					id="xpane-0"
					:data="datajson"
					:loading="loading"
					queryData="ENGBOMViewInfo"
					:filter_thousandth="['self_level_qty','confirm_flag']"
					:filter_language="['status','planning_code']"
					:header="tableHeader"
					:option="tableOption"
					:checkflg="false"
					ref="singleTable"
			></wTable>
			<!--<el-table
				id="xpane-0"
				:data="datajson"
				v-loading="loading"
				:highlight-current-row="true"
				show-overflow-tooltip="true"
				border
				stripe
				size="mini"
				:height="tableHeight"
				header-row-class-name="headerclass"
				:row-class-name="tableRowClassName"
				style="width: 100%; margin-top:0px"
			>
				<el-table-column show-overflow-tooltip prop="Exclusively_ID" label="ID" v-if="false"></el-table-column>
				<el-table-column show-overflow-tooltip prop="PARENT_item_code" :label="$t('getapi[805]')" sortable width="70"></el-table-column>
				<el-table-column show-overflow-tooltip prop="PARENT_part_code" :label="$t('getapi[740]')" sortable width="90"></el-table-column>
				<el-table-column show-overflow-tooltip prop="PARENT_part_version" :label="$t('getapi[741]')" sortable width="90"></el-table-column>
				<el-table-column show-overflow-tooltip prop="PARENT_part_name" :label="$t('getapi[6286]')" sortable width="90"></el-table-column>
				<el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[806]')" sortable width="80"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_code" :label="$t('getapi[807]')" sortable width="90"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_version" :label="$t('getapi[808]')" sortable width="90"></el-table-column>
				<el-table-column show-overflow-tooltip prop="part_name" :label="$t('getapi[6287]')" sortable width="90"></el-table-column>
				<el-table-column show-overflow-tooltip prop="self_level_qty" :label="$t('getapi[726]')" align="right" sortable width="80"></el-table-column>
				<el-table-column show-overflow-tooltip prop="status" :label="$t('getapi[552]')" sortable width="60"></el-table-column>
				<el-table-column show-overflow-tooltip prop="CREATE_PERSON" :label="$t('getapi[410]')" sortable width="70"></el-table-column>
				<el-table-column show-overflow-tooltip prop="CREATE_TIME" :label="$t('getapi[135]')" sortable width="80"></el-table-column>
				<el-table-column show-overflow-tooltip prop="audit_person" :label="$t('getapi[550]')" sortable width="70"></el-table-column>
				<el-table-column show-overflow-tooltip prop="audit_time" :label="$t('getapi[732]')" sortable width="80"></el-table-column>
				<el-table-column show-overflow-tooltip prop="relation_version" :label="$t('getapi[810]')" sortable width="100"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Modify_Person" :label="$t('getapi[733]')" sortable width="70"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Modify_Time" :label="$t('getapi[1210]')" sortable width="80"></el-table-column>
				<el-table-column show-overflow-tooltip prop="WORKCENTER_CODE" :label="$t('getapi[584]')" sortable width="100"></el-table-column>
				<el-table-column show-overflow-tooltip prop="WORKCENTER_NAME" :label="$t('getapi[882]')" sortable width="100"></el-table-column>
				<el-table-column show-overflow-tooltip prop="confirm_flag" :label="$t('getapi[6381]')" sortable width="100"></el-table-column>
				<el-table-column show-overflow-tooltip prop="Routing_Sequence" :label="$t('getapi[573]')" sortable width="80"></el-table-column>
			</el-table>-->
			<el-row class="page">
				<el-col :span="18">
					<el-pagination
						@size-change="handleSizeChange"
						@current-change="handleCurrentChange"
						:page-sizes="[50, 100, 200, 300, 400]"
						:page-size="PageSize"
						background
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</el-col>
				<el-col :span="6">
					<div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">表明/视图名称:{{ DbTbNames }}</div>
				</el-col>
			</el-row>
		</div>
		<serce :isVisible="isVisible" queryData="ENGBOMViewInfo" ref="ser" @getser="serclick"></serce>
		<ctable :isVisible="false" :title="$t('getapi[69]')" queryData="ENGBOMViewInfo" tabNo="0" ref="ctab"
				@getctab="sortclick"></ctable>
	</div>
</template>
<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';

export default {
	name:'overviewBOM',
    computed: {
        tableOption() {
            return {
                border: true,
                height: this.$windowSize.tableHeight3,
                maxHeight: this.$windowSize.tableHeight3,
            }
        },
        tableHeight(){
            return this.$windowSize.tableHeight3
        }
    },
	data() {
		return {
            tableHeader: [],
			ids: '',
			showloading: '',
			isVisible: false,
			DbTbNames: '', //表名
			datajson: [],
			queryData: [],
			PageIndex: 1,
			PageSize: this.$http.getPageSize('overviewBOM'),
			SelectIndex: 0,
			total: 0, // 数据总量
			loading: false, // 主表加载状态
            scrollTop:0,
		};
	},
	mounted: function() {
		let that = this;
        that.colsort();
		that.authority();
        that.$nextTick(function () {
            that.$processdata.initForm()
        })
	},
    activated () {
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop = res.target.scrollTop
            },false)
        }, 5000);
        // 路由跳转回来滚动到离开时的位置
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
            }, 13)
        })

    },
	methods: {
        colsort() {
            let that = this;
            that.$loadviewfields.Fileds('ENGBOMViewInfo', 0, PFileds => {
                that.tableHeader = PFileds;
            });
        },
        sortclick(val) {
            if (val == 1) {
                this.colsort();
            }
        },
        // 修改表格顺序
        opentable() {
            this.$refs.ctab.clearInputs(true);
        },
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[69]"),this.$t("getapi[18]"));
        },
		authority() {
			let that = this;
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
			//只读权
			if (that.$limits.ReadOnlyRightsView('plv2', 32, 1, that.total)) {
				if (that.total > 0) {
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
				} else {
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
				}
			}
			//操作权限-查询级别
			var limits = that.$limits.OperationAuthorityView('plv2', 32, 1, that.total);
			// limits说明： 1 查询权限、2 编辑权限、3 删除权限(列表行数>0)、4 删除权限(列表行数<0)
			switch (limits) {
				case -1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 1:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 2:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				case -3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh');
					break;
				case 3:
					that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
					break;
				default:
					break;
			}
		},
		// 查询
		search() {
			this.isVisible = true;
			this.$refs.ser.clearInput(this.isVisible, 'ENGBOMViewInfo');
		},
		// 刷新
		reflash() {
			this.intidata();
		},
		//获取查询条件
		serclick(val) {
			this.queryData = val;
			this.intidata();
		},
		intidata() {
			let that = this;
			that.loading = true;
			this.isVisible = false;
			let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: '',
				row_sign: '',
				query_sort: ''
			};
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Param: []
			};
			that.queryData.forEach(item => {
//				if(item.query_Condition==''||item.query_Condition.length>0) {
					pm = {
						row_sign: item.row_sign,
						query_Condition: item.query_Condition,
						query_sort: item.query_sort,
						query_field_type: item.Query_Field_Type,
						query_field_name: item.Query_Field_Name
					};
					parm.Param.push(pm);
//				}
			});
			console.log(parm);
			that.$http.urlpost('/Eng/Boms/DataList', parm, function(res) {
				console.log(res);
				if (res.Success == 1) {
					that.datajson = res.DataContent;
					that.total = res.Totals;
					that.DbTbNames = res.DbTbNames;
				}
				that.loading = false;
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
				that.authority();
			});
		},
		//修改页数
		handleSizeChange(val) {
			this.PageSize = val;
            this.$http.savePageSize('overviewBOM',val)
			this.intidata();
			this.authority();
		},
		//跳页
		handleCurrentChange(val) {
			this.SelectIndex = val;
			this.intidata();
			this.authority();
		},
		imp() {
			let item = {
				//label: 'BOM导入',
                label: '通用导入',
				name: 'exp',
				path: '/exp/1',
				url: '/exp/1',
				icon: 'video-play'
			};
			this.$router.push({ path: '/exp/' });
			this.$store.commit('selectMenu', item);
		},
		exps() {
			/*let that = this;
			that.loading = true;
			let pm = {
				query_Condition: '',
				query_field_type: '',
				query_field_name: '',
				row_sign: '',
				query_sort: ''
			};
			let parm = {
				PageIndex: that.PageIndex,
				PageSize: that.PageSize,
				SelectIndex: that.SelectIndex,
				Param: []
			};
			that.queryData.forEach(item => {
//				if(item.query_Condition==''||item.query_Condition.length>0) {
					pm = {
						row_sign: item.row_sign,
						query_Condition: item.query_Condition,
						query_sort: item.query_sort,
						query_field_type: item.Query_Field_Type,
						query_field_name: item.Query_Field_Name
					};
					parm.Param.push(pm);
//				}
			});
			that.$http.urlpost('/Eng/Boms/ListToExecl', parm, function(res) {
				if (res.Success == 1) {
					let hrefurl = Common.Url + res.DataContent.URL;
					window.open(hrefurl);
				} else {
					that.$message.error(res.Msg);
				}
				that.loading = false;
			});*/
            let that = this;
            let datac = [];
            for (let i = 0; i < that.queryData.length; i++) {
                datac.push({
                    query_Condition: that.queryData[i].query_Condition,
                    query_field_type: that.queryData[i].Query_Field_Type,
                    query_field_name: that.queryData[i].Query_Field_Name,
                    query_sort: that.queryData[i].query_sort,
                    row_sign: that.queryData[i].row_sign
                });
            }
            let parm = {
                query_sign: "ENGBOMViewInfo",
                fromname: that.$t('getapi[69]'),
                SelectIndex: that.SelectIndex,
                MultyVer: that.$processdata.getLanguage(),
                Param: datac
            };
            that.$processdata.commonExport(parm)
		}
	}
};
</script>

<style scoped lang="less">
.c-search-table {
	width: 100%;
	height: calc(~'100% - 10px'); /*这里我用了计算属性*/
}

.beauty-Scroll {
	.el-scrollbar {
		height: 100%; /*此处一定要设置高度，不然内层的计算属性不生效*/
	}
	.el-scrollbar__wrap {
		width: calc(~'100% + 17px'); /*将垂直滚动条挤到可视区域之外*/
		height: calc(~'100% + 17px'); /*将水平滚动条挤到可视区域之外*/
	}
}

input {
	width: 100%;
	height: 35px;
	border-radius: 8px;
	border: 1px solid #dcdfe6;
	padding-left: 2px;
	padding-right: 2px;
}

table {
	border-collapse: separate;
	border-spacing: 0px 5px;
	td {
		padding-left: 3px;
	}
}

.alignment-left {
	text-align: left;
}

.alignment-right {
	text-align: right;
}
.el-pagination {
	white-space: inherit;
}
</style>
